module.exports = __webpack_public_path__ + "img/chevron-double-left.af9a189e.svg";